import { defineMessages } from 'react-intl';

const messages = defineMessages({
  question1: {
    defaultMessage: 'How many times can I play a loan card?',
  },
  answer1: {
    defaultMessage:
      "You can play your loan card in every eligible competition for 3 Game Weeks. They don't have to be consecutive but your cards expire after the 6th Game Week",
  },
  question2: {
    defaultMessage: 'What happens at the end of the loan period?',
  },
  answer2: {
    defaultMessage:
      'The cards expire and return to Sorare. But you can buy any card at any point during of after the loans expire',
  },
  question3: {
    defaultMessage: 'Can I play my loan cards with other cards?',
  },
  answer3: {
    defaultMessage:
      'Yes, during the loan period, you can play your loan cards alongside other cards you own in eligible competitions. This allows you to build a mixed lineup combining your loaned and purchased cards while participating in various competitions',
  },
  question4: {
    defaultMessage:
      'I see three lineups: can I pick cards from different lineups to compose my team?',
  },
  answer4: {
    defaultMessage:
      'No, you must select all cards from one single premade lineup',
  },
  question5: {
    defaultMessage: 'What are the other ways to acquire cards?',
  },
  answer5: {
    defaultMessage:
      'You can buy cards directly on the marketplace, participate in auctions, or win cards through tournament rewards',
  },
});

export const faqMessages = [
  {
    question: messages.question1,
    answer: messages.answer1,
  },
  {
    question: messages.question2,
    answer: messages.answer2,
  },
  {
    question: messages.question3,
    answer: messages.answer3,
  },
  {
    question: messages.question4,
    answer: messages.answer4,
  },
  {
    question: messages.question5,
    answer: messages.answer5,
  },
];
